export enum EnumStatusPerfil {
    Ativado,
    Bloqueado,
    Convidado
}